<div class="app-modal">
  <div mat-dialog-title class="draw-compliance-header">Confirmation required!</div>
  @if (data && data.note) {
    <div mat-dialog-content>
      <p>{{ data.note }}</p>
      <table class="reason-table">
        <tr>
          <td class="param-label">Reason</td>
          <td class="param-value">
            <mat-form-field>
              <mat-label>Reason</mat-label>
              <input data-id="inputConfirmationReason" matInput [formControl]="reasonControl" />
            </mat-form-field>
          </td>
        </tr>
      </table>
    </div>
  }
  <div mat-dialog-actions class="action-buttons">
    <button data-id="confirmButton" mat-raised-button [color]="'primary'" (click)="proceed()">Proceed</button>
    <button data-id="cancelButton" mat-raised-button [color]="'warn'" [mat-dialog-close]="null">Dismiss</button>
  </div>
</div>
